import { render, staticRenderFns } from "./welcomeModal.vue?vue&type=template&id=2826d0b7&scoped=true&"
import script from "./welcomeModal.vue?vue&type=script&lang=js&"
export * from "./welcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./welcomeModal.vue?vue&type=style&index=0&id=2826d0b7&scoped=true&lang=scss&"
import style1 from "./welcomeModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826d0b7",
  null
  
)

export default component.exports